import React, { useState, useEffect } from 'react';
import { Activity, Heart, Zap, Shield, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
export default function TestosteroneReplacementTherapyTRT() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = () => {
    if ((window as any).Calendly) {
      (window as any).Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
  };
  const benefits = [{
    icon: Zap,
    title: "Enhanced Energy & Vitality",
    description: "Wake up with energy that lasts all day\nLook and feel like you're in control again (not worn down)"
  }, {
    icon: Heart,
    title: "Improved Libido & Performance",
    description: "Confidence in the bedroom and the boardroom"
  }, {
    icon: Activity,
    title: "Muscle Mass & Strength",
    description: "Lose stubborn body fat while also building muscle"
  }, {
    icon: Shield,
    title: "Better Sleep Quality",
    description: "Sleep deeply and wake up refreshed, not foggy"
  }];
  const procedures = [{
    step: "01",
    title: "Understand Where You Are Now",
    description: "We start with a complete picture of your health and how your energy, recovery, and performance are tracking today."
  }, {
    step: "02",
    title: "Create Your Personal Path to Feeling Better",
    description: "Not a template — a plan built around your goals and lifestyle."
  }, {
    step: "03",
    title: "Support You Daily as You Change",
    description: "Ongoing check-ins and adjustments to keep you progressing."
  }, {
    step: "04",
    title: "Get You to a New Normal",
    description: "Where energy, confidence, and physical performance work for you — not against you."
  }];
  return;
}